import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL
  || 'https://pyenbriacaivrnkwitqu.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY
  || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB5ZW5icmlhY2FpdnJua3dpdHF1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyNjExNjAsImV4cCI6MjA5MjgzNzE2MH0.VJsQRGFdiC4ahPDA9vsfgc13MKrEiPZHSdCdlysYaPk';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

